export default __webpack_public_path__ + "static/Picto_feuille_3-83cbd8a208bf1ac672f6b3e8a75fd772.png";